import React, { useEffect, useRef } from "react";
import styles from "./index.module.less";
import cx from "classnames";
import { CaretRightOutlined } from "@ant-design/icons";
import { g4 } from "../../../utils/helper";
import ScrollNumber from "antd/lib/badge/ScrollNumber";

interface IProps {
  data: {
    time: string;
    id: string;
    tag: string;
    thumb: string;
    title: string;
    views: string | number;
    likes: number;
    link: string;
  };
  navList?: any[];
  className?: string;
  style?: any;
  likeIconShow?: boolean;
  urlParams?: string;
  itemTitleLineClamp?: number;
  onClickItem?: () => void;
  onExposuredItem?: () => void;
}

const CarItem: React.FC<IProps> = (props: IProps) => {
  const {
    data,
    navList,
    className,
    style,
    urlParams,
    likeIconShow = true,
    itemTitleLineClamp = 2,
    onClickItem,
    onExposuredItem,
  } = props;
  const contentRef = useRef<any>(null);

  const nofind = (ev) => {
    ev.target.src = "https://p3.8891.com.tw/nc/newcar/2022/08/23/1661251265667372.png";
    ev.target.onerror = null;
  };

  useEffect(() => {
    let isFrist = false;
    const observe = new IntersectionObserver(
      (entrie) => {
        if (entrie[0].isIntersecting && !isFrist) {
          isFrist = true;
          setTimeout(() => {
            onExposuredItem && onExposuredItem();
            if (window.SLUG && window.SLUG !== "") {
              g4("element_exposured", {
                page_name: "影音欄目列表頁",
                element: "列表",
                element_id: "影音列表",
                object_type: "影音",
                object_id: data.id,
              });
            }
          }, 500);
        }
      },
      { threshold: 0.75 },
    );
    contentRef.current && observe.observe(contentRef.current);
  }, []);

  if (!data) {
    return null;
  }

  return (
    <div id="MovieItem" data-id={data.id} className={cx(styles["video-item"])} ref={contentRef} style={style}>
      <a
        target='_blank'
        href={window.SLUG && window.SLUG !== "" ? data.link : `/movies/${data.id}${urlParams || ""}`}
        onClick={() => {
          onClickItem
            ? onClickItem()
            : g4("video_clicked", {
                page: window.SLUG && window.SLUG !== "" ? "影音欄目詳情頁" : "首頁-影音",
                module: navList && navList.length > 0 ? "熱門影片" : "品牌選車",
                element: "影音",
                element_id: data.id,
              });
        }}
      >
        <div className={cx(styles["img-box"], className)}>
          <img className={cx(styles["item-thumb"])} src={data.thumb} alt={data.title} onError={nofind} />
          <img src='https://photo.8891.com.tw/2023/08/15/1692090155275148.png' className={styles["item-play"]} alt='' />
        </div>

        <div
          className={cx(styles["item-title"], {
            [styles["item-title-line-1"]]: itemTitleLineClamp === 1,
            [styles["item-title-line-2"]]: itemTitleLineClamp === 2,
          })}
        >
          {data.title}
        </div>
        {window.SLUG && window.SLUG !== "" ? (
          <div className={cx(styles["item-bottom-box"])}>
            <div className={cx(styles["item-bottom-left"])}>
              {data.views ? <span>{data.views}次播放</span> : <></>}
              {data.likes !== 0 && likeIconShow ? (
                <span>
                  <img
                    src='https://p3.8891.com.tw/nc/newcar/2022/08/23/1661253208774552.png'
                    alt=''
                    style={{ margin: "0 14px 0 0" }}
                  />
                  {data.likes}
                </span>
              ) : (
                <></>
              )}
            </div>
            <span>{data.time}</span>
          </div>
        ) : (
          <div className={cx(styles["item-bottom"])}>
            {data.views ? <span>{data.views}次播放</span> : <></>}
            {data.likes !== 0 && likeIconShow ? (
              <span>
                <img
                  src='https://p3.8891.com.tw/nc/newcar/2022/08/23/1661253208774552.png'
                  alt=''
                  style={{ margin: "0 14px 0 0" }}
                />
                {data.likes}
              </span>
            ) : (
              <></>
            )}
          </div>
        )}
      </a>
    </div>
  );
};
export default CarItem;
